import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux'
import axios from 'axios';
import $ from 'jquery';

//material-ui
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import StepConnector from '@material-ui/core/StepConnector';
import { isMobile } from 'react-device-detect';
import StepContent from '@material-ui/core/StepContent';
import StepButton from '@material-ui/core/StepButton';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import InformacionObligatoria from './InformacionObligatoria';
import InformacionPersonal from './InformacionPersonal';
import Domicilio from './Domicilio';
import Confirmacion from './Confirmacion';

class DatosPersonales extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
            formSubmitted:false,
            skipped: new Set(),
        }

        this.informacionObligatoriaRef = React.createRef();
        this.informacionPersonalRef = React.createRef();
        this.domicilioRef = React.createRef();
        this.confirmacionRef = React.createRef();

        this.isStepOptional = this.isStepOptional.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleSkip = this.handleSkip.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.isStepSkipped = this.isStepSkipped.bind(this);
        this.getSteps = this.getSteps.bind(this);
        this.isStepSkipped = this.isStepSkipped.bind(this);
        this.handleStep = this.handleStep.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.content = this.content.bind(this);
        this.mobileContent = this.mobileContent.bind(this);

    }

    isStepOptional = step => step === 0;

    
    isConfirmarDataOk(){
        let { simulacion ,confirmacion} = this.props;

        return  simulacion.huboSimulacion &&
                simulacion.monto > simulacion.montoMin &&
                simulacion.monto < simulacion.montoMax &&
                simulacion.plazoDias <= simulacion.plazoMax &&
                simulacion.plazoDias >= simulacion.plazoMin &&
                confirmacion.acceptTerminosCondiciones === true &&
                confirmacion.isCbuOk === true
    }

    handleNext = () => {
        const { activeStep } = this.state;
        let wasError = false
        
        if(activeStep === 0 && !this.informacionObligatoriaRef.current.isDataOk()) {
            this.props.history.push('/plazo-fijo/PF-solicitud-no-procesada');
            return
        }

        //step 1
        if(activeStep === 1) {
            if(!this.informacionPersonalRef.current.isDataOk()){
                wasError = true
                this.informacionPersonalRef.current.snackbar();  
                this.informacionPersonalRef.current.forceSubmit();              
            }
        }
        
        //step 2
        if(activeStep === 2){ 
            if(!this.domicilioRef.current.isDataOk()) {
                wasError = true
            }
            this.domicilioRef.current.forceSubmit();
        }

        if(!wasError){
            this.setState({
                formSubmitted:false,
                activeStep: activeStep + 1
            })
        }else{
            this.setState({
                formSubmitted:true
            })
        }
    };

    handleFinish = () => {
        $(".load").fadeIn(700);
    

        let data = {
                plazoFijo: {
                    monto: this.props.simulacion.monto,
                    plazo: this.props.simulacion.plazoDias,
                },
                cuenta: {
                    cbu: this.props.confirmacion.cbuAlias
                },
                persona: {
                    sexo: this.props.primerFormulario.genero,
                    apellido: this.props.primerFormulario.apellido,
                    nombre: this.props.primerFormulario.nombre,
                    versionDocumentos: this.props.primerFormulario.versionDocumento,
                    dni: this.props.primerFormulario.dni,
                    tipoIdTributario: this.props.primerFormulario.tipo,
                    ejemplarDocumento: this.props.primerFormulario.ejemplar,
                    idTributario: this.props.primerFormulario.idTributario,
                    idSituacionLaboral: this.props.datosPersonales.tipo,
                    idPaisNacimiento: this.props.datosPersonales.paisNacimiento,
                    idNacionalidad: this.props.datosPersonales.nacionalidad,
                    ciudadNacimiento: this.props.datosPersonales.ciudad,
                    fechaNacimiento: this.props.datosPersonales.fechaNac,
                    email: this.props.primerFormulario.email,
                    estadoCivil: this.props.datosPersonales.estadoCivil,
                    cantidadNupcias:  this.props.datosPersonales.nupcias,
                    direccion: [{
                        calle: this.props.informacionDomicilio.calle,
                        numero: this.props.informacionDomicilio.numeroDomicilio,
                        depto: this.props.informacionDomicilio.departamento || "",
                        piso: this.props.informacionDomicilio.piso || "",
                        provinciaId : this.props.informacionDomicilio.provinciaId,
                        localidadId: this.props.informacionDomicilio.localidadSeleccionada,
                        codigoPostal: this.props.informacionDomicilio.codigo
                    }],
                    telefono: [{
                        telCelCarac: this.props.primerFormulario.telefonoMovil.substring(2,6),
                        telCelDdn: this.props.primerFormulario.telefonoMovil.substring(0,2),
                        telCelNumero: this.props.primerFormulario.telefonoMovil.substring(6,10)
                    }],
                    datosConyugue: {
                      nombre: this.props.datosPersonales.nombreConyuge,
                      apellido: this.props.datosPersonales.apellidoConyuge,
                      dni: this.props.datosPersonales.dniConyuge,
                      ejemplarDocumento: this.props.datosPersonales.ejemplarConyuge,
                      idTributario:this.props.datosPersonales.cuilConyuge,
                      tipoIdTributario: this.props.datosPersonales.tipoConyuge,
                      sexo: this.props.datosPersonales.generoConyuge,
                    }
                },
                tipo: this.props.simulacion.tipoPlazoFijo === 1 ? "PESOS" : "UVAS" 
            }
      axios({
            method: 'post',
            timeout: 60 * 4 * 1000,
            url: localStorage.getItem('url') + '/api/plazoFijo/constituir',
            data
        },{withCredentials: true}).then(response => {
            $(".load").fadeOut(700);

            if (response.status === 200) {
                this.props.history.push('/plazo-fijo/PF-congrats');
            }else{
                this.props.history.push('/plazo-fijo/PF-fail');
            }
        }).catch(error => {
            //TODO
            $(".load").fadeOut(700);
            this.props.history.push('/plazo-fijo/PF-fail');
        });
    }

    handleBack = () => {
        this.setState(state => ({
            activeStep: state.activeStep - 1,
        }));
    };

    handleSkip = () => {
        const { activeStep } = this.state;
        if (!this.isStepOptional(activeStep)) {
            throw new Error("You can't skip a step that isn't optional.");
        }
        this.setState(state => {
            const skipped = new Set(state.skipped.values());
            skipped.add(activeStep);
            return {
                activeStep: state.activeStep + 1,
                skipped,
            };
        });
    };

    handleReset = () => {
        this.setState({
            activeStep: 0,
        });
    };

    isStepSkipped(step) {
        return this.state.skipped.has(step);
    }

    getSteps() {
        let {landing} = this.props

        let labelLastStep = "Revisar y Confirmar"

        if(landing === "" || landing.monto === 0){
            labelLastStep = "Simular y Confirmar"
        }

        return ['Información', 'Datos personales', 'Domicilio', labelLastStep];
    }



    isStepFailed = step => step === 2;

    handleStep = step => () => {
        this.setState({
            activeStep: step,
        });
    };

    mobileContent(activeStep, steps, classes){
        return  <StepContent> {this.content( activeStep,steps,classes )  }</StepContent>
    }

    content(activeStep, steps, classes) {
        let nextDisabled = false

        if( activeStep === 3 && !this.isConfirmarDataOk() ){
            nextDisabled = true
        }
        //saque la eleccion del step content del switch y la puse a k porque
        //en la version mobile crasheaba
        let stepContent = null

        let stepContent0 = <InformacionObligatoria activar={activeStep} innerRef={this.informacionObligatoriaRef} />;
        let stepContent1 = <InformacionPersonal activar={activeStep} innerRef={this.informacionPersonalRef} externalSubmitted={this.state.formSubmitted}  />;
        let stepContent2 = <Domicilio activar={activeStep} innerRef={this.domicilioRef} externalSubmitted={this.state.formSubmitted} />;
        let stepContent3 = <Confirmacion activar={activeStep} innerRef={this.confirmacionRef} externalSubmitted={this.state.formSubmitted}  />;

        if( activeStep === 0){
            stepContent = stepContent0
        }

        if( activeStep === 1){
            stepContent = stepContent1
        }

        if( activeStep === 2){
            stepContent = stepContent2
        }

        if( activeStep === 3){
            stepContent = stepContent3
        }

        return <div>
            {activeStep === steps.length ? (
                <div>
                    <Typography className={classes.instructions}>
                        All steps completed - you&apos;re finished
                    </Typography>
                    <Button onClick={this.handleReset} className={classes.button}>
                        Reset
                        </Button>
                </div>
            ) : (
                    <div>
                        <div className={classes.instructions}>
                            { stepContent }
                        </div>

                        <div className="button-container">
                            <Button
                                disabled={activeStep === 0}
                                onClick={this.handleBack}
                                className={classes.button}>
                                Anterior
                            </Button>
                            <Button
                                disabled={ nextDisabled }
                                variant="contained"
                                color="primary"
                                onClick={activeStep === steps.length - 1 ? this.handleFinish : this.handleNext}
                                className={classes.button + " " + classes.btnbNoShadow}>
                                {activeStep === steps.length - 1 ? 'Confirmar' : 'Siguiente'}
                            </Button>
                        </div>
                    </div>
                )}
        </div>
    }

    render() {

        console.log("this.props.simulacion")
        console.log(this.props.simulacion)
        console.log("this.props.simulacion")

        const { classes } = this.props;
        const steps = this.getSteps();
        const { activeStep } = this.state;
        const connector = (
            <StepConnector
                classes={{
                    active: classes.connectorActive,
                    completed: classes.connectorCompleted,
                    disabled: classes.connectorDisabled,
                    line: classes.connectorLine,
                }}
            />
        );

        return (
            <div className="datos-personales">
                <Header />
                <div className="datos-personales-container">
                    <div className={classes.root}>
                        <Stepper activeStep={activeStep} 
                                 className="stepper"
                                 connector={connector} 
                                 orientation={isMobile ? "vertical" : "horizontal"}>

                            {
                                steps.map((label, index) => {
                                    const props = {};
                                    const labelProps = {};
                                    if (this.isStepOptional(index)) {
                                        labelProps.optional = <Typography variant="caption" className="caption">Obligatoria</Typography>;
                                    }
                                    if (this.isStepSkipped(index)) {
                                        props.completed = false;
                                    }

                                    let content = null
                                    if(index === activeStep){
                                        content = this.mobileContent(activeStep, steps, classes)
                                    }
                                    
                                    return (
                                        <Step key={label} {...props}>
                                            <StepButton  {...labelProps} onClick={this.handleStep(index)}>
                                                {label}
                                            </StepButton >

                                            { isMobile && content }
                                        </Step>
                                    );
                                })
                            }

                        </Stepper>

                        {!isMobile && this.content(activeStep, steps, classes)}
                    </div>
                </div>
                <Footer active={activeStep} />

            </div>
        );
    }
}

const styles = theme => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing.unit,
        '&:hover':{
            color: '#fff',
            backgroundColor: '#fa9c5f'
        }
    },

    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    },
    connectorActive: {
        '& $connectorLine': {
            borderColor: theme.palette.primary.main,
        },
    },
    connectorCompleted: {
        '& $connectorLine': {
            borderColor: theme.palette.primary.main,
        },
    },
    connectorDisabled: {
        '& $connectorLine': {
            borderColor: theme.palette.grey[100],
        },
    },
    connectorLine: {
        transition: theme.transitions.create('border-color'),
    },
    btnbNoShadow: {
        boxShadow:"0px 0px 0px 0px !important"
      }
});


const mapStateToProps = function (state) {
    return {
        landing: state.plazoFijoLandingPage.data,
        datosBasicos: state.plazoFijoPrimerFormulario,
        datosPersonales: state.plazoFijoInformacionPersonal,
        simulacion: state.plazoFijoSimulador,
        confirmacion: state.plazoFijoConfirmacion,
        primerFormulario: state.plazoFijoPrimerFormulario,
        informacionDomicilio: state.plazoFijoInformacionDomicilio,
        informacionObligatoria: state.plazoFijoInformacionObligatoria
    }
}

export default compose(
    connect(mapStateToProps),
    withStyles(styles))
    (DatosPersonales);



// WEBPACK FOOTER //
// ./src/components/PlazoFijo/datosPersonales/DatosPersonales.js